export const RICH_BLOCK_EDIT_EVENT = 'richBlockEdit'
